import React from "react";
import ReactSelect from "react-select";

const defaultFilter = (candidate, inputValue) => {
    const search = String(inputValue || '').toLowerCase();

    const label = String(candidate?.label ?? '').toLowerCase();
    const value = String(candidate?.value ?? '').toLowerCase();

    return label.includes(search) || value.includes(search);
};

const Select = React.forwardRef((props, ref) => {
    const autoSearchable =
        props.isSearchable ?? ((props.options?.length || 0) > 1);
    const handleKeyDown = (e) => {
        const blockedKeys = [' ', 'Enter', 'Tab'];

        const isEmptySearch =
            !e.target?.value ||
            e.target.value.trim() === '';

        if (blockedKeys.includes(e.key) && isEmptySearch) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        props.onKeyDown?.(e);
    };
    return (
        <ReactSelect
            ref={ref}
            {...props}
            onKeyDown={handleKeyDown}
            isSearchable={autoSearchable}
            filterOption={props.filterOption ?? defaultFilter}
            noOptionsMessage={props.noOptionsMessage ?? (() => "Nothing found")}
        />
    );
});

export * from "react-select";
export default Select;